
















import Vue from 'vue';
import Grid from '@/components/grid/Grid';

export default Vue.extend({
  components: { Grid },

  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    namePrefix: {
      type: String,
    },
  },

  computed: {
    errorFields() {
      return {
        sheet: {
          label: this.$t('Sheet name'),
          sortable: false,
        },
        index: {
          label: this.$t('Number of row'),
          sortable: false,
        },
        key: {
          label: this.$t('Field name'),
          sortable: false,
        },
        code: {
          label: this.$t('Reason'),
          sortable: false,
          format: (code: string | null | undefined, row: any): string => {
            const $i18n = this.$parent.$i18n;
            if (code) {
              const localeMessages = $i18n.getLocaleMessage($i18n.locale);
              if (localeMessages && localeMessages.importError && localeMessages.importError.hasOwnProperty(code)) {
                return this.$t(`importError.${code}`, row) as string;
              }
            }

            if (row.reason) {
              return row.reason;
            }

            if (row.message) {
              return row.message;
            }

            return '';
          },
        },
      };
    },
  },
});
